/// <reference types="react-scripts" />
import React from 'react';
import { App } from 'app';
import { render } from 'react-dom';
import { initSentry } from 'shared/sentry';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

initSentry();

render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
